import React from 'react';
import { useTranslation } from 'react-i18next';

import { BonusStatus, BonusIdentifier } from 'constants/appEnums';

import BonusCardDetailsView from './BonusCardDetailsView';

interface IBonusDetailsProps {
  bonusState: BonusStatus;
  expiryDate?: string;
  onActivateClick?: () => void;
}

export const NewSigningDetails: React.FC<IBonusDetailsProps> = ({ bonusState, expiryDate, onActivateClick }) => {
  const { t } = useTranslation();

  return (
    <BonusCardDetailsView titleIcon={BonusIdentifier.NewSigning} titleText={t(BonusIdentifier.NewSigning)} bonusState={bonusState} onActivateClick={onActivateClick}>
      <>
        <p>{t('not-a-fan-of-a-player-you-revealed-swap-a-player-out-for-anothe-player-completely-at-random')}</p>
        <h2>{t('how-does-it-work')}</h2>
        <p>{t('awarded-at-the-start-of-round-or-when-the-bet-is-settled-the-bonus-can-be-used-anytime-until-first-game')}</p>
        <h2>{t('what-are-my-constraints')}</h2>
        <p>{t('you-need-to-activate-this-card-before-the-first-match-kicks-off-in-your-team')}</p>
        <p>{t('you-cannot-activate-if-you-have-already-activated-another-bonus-card')}</p>
        <h2>{t('when-will-this-card-expire')}</h2>
        <p>{expiryDate ?? t('six-weeks-after-you-have-qualified')}</p>
      </>
    </BonusCardDetailsView>
  );
};

export const DecisionTimeDetails: React.FC<IBonusDetailsProps> = ({ bonusState, expiryDate, onActivateClick }) => {
  const { t } = useTranslation();

  return (
    <BonusCardDetailsView titleIcon={BonusIdentifier.DecisionTime} titleText={t(BonusIdentifier.DecisionTime)} bonusState={bonusState} onActivateClick={onActivateClick}>
      <>
        <p>{t('have-the-option-of-two-players-to-choose-from-on-friday')}</p>
        <h2>{t('how-does-it-work')}</h2>
        <p>{t('two-players-are-revealed-at-once-you-have-the-option-of-choosing-one-to-make-your-team-stronger-between-two-players-at-random-on-friday')}</p>
        <h2>{t('what-are-my-constraints')}</h2>
        <p>{t('you-need-to-activate-this-card-before-you-reveal-the-fifth-player')}</p>
        <p>{t('you-cannot-activate-if-you-have-already-activated-another-bonus-card')}</p>
        <h2>{t('when-will-this-card-expire')}</h2>
        <p>{expiryDate ?? t('six-weeks-after-you-have-qualified')}</p>
      </>
    </BonusCardDetailsView>
  );
};
